import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SuiProvider from './sui/SuiProvider';
import './i18n/config';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.Suspense
    fallback={
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#0a0a12',
          color: '#f0f0f5',
        }}
      >
        Loading...
      </div>
    }
  >
    <SuiProvider>
      <App />
    </SuiProvider>
  </React.Suspense>
);
